var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "production_ico") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large_review",
    transform: "translate(-25.000000, -290.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "production_ico",
    transform: "translate(25.000000, 290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "12 0.7499 0.75 5.2499 12 9.7499 23.25 5.2499"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    points: "0.75 5.2499 0.75 18.7499 12 23.2499 12 9.7499"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    points: "23.25 5.2499 23.25 18.7499 12 23.2499 12 9.7499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1875,7.2753 L6.9375,2.7753",
    id: "Stroke-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.625,16.5 L18.75,17.25",
    id: "Stroke-10"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.f61fb676f897da68b5aa1a6134c97867.svg";
export { ForwardRef as ReactComponent };